import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: 'stripemail',
    standalone: false
})
export class StripEmailPipe implements PipeTransform {
  transform(value: string): string {
    if (value) {
      const splitted = value.split('@');
      if (splitted.length) {
        return splitted[0]
      }
    }
  }
}